import ActionsPanel from './ActionsPanel';

export default ActionsPanel;
